<span [ngSwitch]="value">
  <span class="badge bg-success" *ngSwitchCase="true"> {{'common.yes' | translate}}</span>
  <span class="badge bg-info" *ngSwitchDefault>{{'common.no' | translate}}</span>

</span>
